import { render, staticRenderFns } from "./ReceiveMessageList.vue?vue&type=template&id=016d5b91&scoped=true&lang=pug"
import script from "./ReceiveMessageList.vue?vue&type=script&lang=ts"
export * from "./ReceiveMessageList.vue?vue&type=script&lang=ts"
import style0 from "./ReceiveMessageList.vue?vue&type=style&index=0&id=016d5b91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016d5b91",
  null
  
)

export default component.exports